import { render, staticRenderFns } from "./BCXMessengerSortPanel.vue?vue&type=template&id=974c4352&scoped=true"
import script from "./BCXMessengerSortPanel.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerSortPanel.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerSortPanel.vue?vue&type=style&index=0&id=974c4352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974c4352",
  null
  
)

export default component.exports